import { createErrorPageWithoutRouter } from '@mysaiva/core/components'

// Use router-free version for Sentry boundary (outside BrowserRouter)
export const ErrorPage = createErrorPageWithoutRouter()
